import request from '@/plugins/axios'
import { getBaseUrl, getParameter } from '@/utils/endpoint'

export const getListPayment = (params = {}) => {
    const new_params = { ...getParameter(), ...params }
    return request.get(getBaseUrl() + '/paymentmodes/paymentchanel', { params: new_params });
}

export const orderPayment = (data) => {
    return request.post(getBaseUrl() + '/placereservation/order', data)
}

export const sendReceiptWa = (id, data) => {
    return request.post(getBaseUrl() + `/placereservation/order/sendwa/${id}`, data)
}

export const sendReceiptEmail = (id, data) => {
    return request.post(getBaseUrl() + `/placereservation/order/sendemail/${id}`, data)
}

export const getSelfOrder = (id) => {
    return request.get(getBaseUrl() + `/selfsalesorder/${id}`)
}

export function cancelOrder(id, data, params = {}) {
    const new_params = { ...getParameter(), ...params }
    return request.put(getBaseUrl() + '/selfsalesorder/cancelledorder/' + id, data, { params: new_params })
  }